"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("g", {
    fill: "currentColor"
  }, (0, _pragma.createFelaElement)("path", {
    d: "M17.016 8.25l-5.485 13.5h2.215l1.148-2.719h4.244l1.148 2.719H22.5zm-1.251 8.719l1.25-3.851 1.252 3.85z"
  }), (0, _pragma.createFelaElement)("path", {
    fillRule: "evenodd",
    d: "M15.92 4.6V3h-5.9v1.6h1.74v4.74H8.5c-.413-.453-.947-.72-1.6-.8.587-.16 1.053-.467 1.4-.92s.52-1.02.52-1.7c0-.907-.313-1.627-.94-2.16-.627-.533-1.513-.8-2.66-.8-.733 0-1.42.127-2.06.38v1.78c.587-.32 1.247-.48 1.98-.48 1.16 0 1.74.5 1.74 1.5 0 .493-.173.88-.52 1.16-.333.28-.827.42-1.48.42h-.64V9.4h.74c1.547 0 2.32.567 2.32 1.7 0 .693-.22 1.2-.66 1.52-.44.307-.967.46-1.58.46-.813 0-1.633-.213-2.46-.64v1.8c.773.32 1.613.48 2.52.48 1.293 0 2.293-.313 3-.94.707-.627 1.06-1.447 1.06-2.46 0-.16-.007-.28-.02-.36h2.6v6.14l1.92-4.8V4.6z",
    clipRule: "evenodd"
  })));
}

var _default = 'src/asset/icon/language.icon.svg';
exports.default = _default;
//# sourceMappingURL=language.icon.js.map